export const BACKEND_API_URL = process.env.REACT_APP_SITE_SERVER_URL || "https://site-server.dev.torsunov.pro";
